import React from 'react'
import { Section } from '@components/Sections/Section'

import './SectionPageNavigation.scss'
import type { CMSSectionPageNavigationBlock } from '@/types/sanity'
type SectionPageNavigationProps = {
  content: CMSSectionPageNavigationBlock
}

export const SectionPageNavigation: React.FC<SectionPageNavigationProps> = ({
  content,
}) => {
  const { _id, theme, links } = content

  return (
    <div className="page-navigation-container">
      <Section theme={theme} id={_id}>
        <ul className="page-navigation-section">
          {links.map((link, i) => {
            return (
              <li className="type-label">
                <a href={`#${link.anchor._id}`} key={i}>
                  {link.name}
                </a>
              </li>
            )
          })}
        </ul>
      </Section>
    </div>
  )
}
